import { IonContent, IonPage } from '@ionic/react'

/**
 * What a customer sees when there is no app to show them.
 *
 * It says nothing about why, and there are three reasons for that, in order of
 * how much they matter:
 *
 *   The business is our customer, not this reader. "Trial expired" or
 *   "suspended" on a public screen is us discussing a business's account with
 *   whoever happens to have scanned their QR code — including their own
 *   customers, and their competitors.
 *
 *   "Not found" is a lie that costs the business. Someone who scanned a code on
 *   a counter and got an error concludes the business is gone. This says the app
 *   is not available and points at the obvious alternative.
 *
 *   No branding, deliberately. Rendering the logo and the name over a dead app
 *   makes it look like the business built something broken.
 */
export function Unavailable() {
  return (
    <IonPage>
      <IonContent className="blooq-content">
        <main
          style={{
            display: 'grid',
            placeItems: 'center',
            minHeight: '100%',
            padding: 24,
            textAlign: 'center',
          }}
        >
          <div style={{ maxWidth: 340 }}>
            <h1
              style={{
                fontSize: 22,
                fontWeight: 700,
                letterSpacing: '-0.02em',
                margin: '0 0 10px',
              }}
            >
              This app isn’t available right now.
            </h1>
            <p style={{ color: 'var(--blooq-muted)', margin: 0, fontSize: 15, lineHeight: 1.6 }}>
              If you were trying to book something, please contact the business directly.
            </p>
          </div>
        </main>
      </IonContent>
    </IonPage>
  )
}
